import React, { useState } from "react";
//import { connect } from 'react-redux';
import { useDispatch, useSelector } from 'react-redux'
import { MixcloudSlugSelector  } from '../store/selectors/Selector'

function Podcastplayer({ podcastSlug }){
    
    const podcastSrc = `https://www.mixcloud.com/widget/iframe/?hide_cover=1&autoplay=1&hide_artwork=1&feed=%2FRockMinuteSoup%2F${podcastSlug}%2F`;
    //console.log(` podcastSlug = ${podcastSlug}`)
    
    console.log(` podcastSrc = ${podcastSrc}`)
    const iframeHTML = `
        <iframe
        width="100%"
        height="120"
        allow="autoplay"
        id="rmsmixcloudplayer"
        src="${podcastSrc}"
        frameborder="0">
        </iframe>
        
    `;
 
    function Iframe(props) {
        console.log("In Iframe ")
        return (
            <div className="rmsplayerholder"
                dangerouslySetInnerHTML={{ __html: props.iframe ? props.iframe : "" }}
            />
        );
    }

    return (
        <div style={{ display: (podcastSlug && podcastSlug == "no-slug") ? 'none' : 'block' }}  id="podcastplayer">
            <div className="container">
                <Iframe iframe={iframeHTML} allow="autoplay" />                    
            </div>
        </div>
    )
}


const mapStateToProps = (state) => {
    console.log( )
    return {
        podcastSlug: state.podcastSlug,
    };
};
/*
export default connect(
(state) => ({
        podcastSlug: state.mixcloudSlug
})

)(Podcastplayer);

*/
/*
export const PodcastplayerStore =   connect(
    state => ({ podcastSlug: MixcloudSlugSelector(state) })
)(Podcastplayer);
*/
const PodcastplayerMemo = React.memo(Podcastplayer);

export default function PodcastplayerStore() {
    const podcastSlug = useSelector(MixcloudSlugSelector)
    const dispatch = useDispatch()
    
    return <PodcastplayerMemo podcastSlug={podcastSlug.mixcloudSlug}  />
}
